import { render, staticRenderFns } from "./KGZ.vue?vue&type=template&id=281c85ff&scoped=true&"
import script from "./KGZ.vue?vue&type=script&lang=js&"
export * from "./KGZ.vue?vue&type=script&lang=js&"
import style0 from "./KGZ.vue?vue&type=style&index=0&id=281c85ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c85ff",
  null
  
)

export default component.exports